import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import * as api from './api';

import { CurrentTarifStateData } from './types';

const initialState: CurrentTarifStateData = {
	data: {
		data: {
			act_shift: '',
			agent_show_mbyte: '',
			allow_change_activated: '',
			allow_change_from: '',
			allow_change_negbal: '',
			allow_change_to: '',
			allow_limit: '',
			allways_apply: '',
			archived: '',
			change_cost: '',
			change_group: '',
			change_minday: '',
			change_only_end_day: '',
			change_only_end_period: '',
			change_renew_ip: '',
			default_nat: '',
			do_notify_changes: '',
			free_own_block_period: '',
			get_abon_sum: '',
			id: '',
			iface_id: '',
			imported_id: '',
			inactive_days: '',
			inactive_group: '',
			inactive_tarif: '',
			is_used: '',
			limit: '',
			limit_block_sum: '',
			migration_info: '',
			name: '',
			nat_dyn_end: '',
			nat_dyn_start: '',
			operator: '',
			own_disabled_cost: '',
			own_disabled_countpermounth: '',
			own_disabled_maxdays: '',
			own_disabled_mindays: '',
			own_disabled_usluga: '',
			pk: '',
			plan_comment: '',
			promise_countpermonth: '',
			promise_days: '',
			promise_maxday: '',
			promise_maxpay: '',
			promise_mincreditday: '',
			promise_minpayday: '',
			promise_need_pay_after_prev: '',
			promise_pay_only_this_month: '',
			promise_pay_safeday: '',
			promo_days: '',
			promo_month: '',
			promo_next: '',
			pull_dynamic_ip: '',
			pull_dynamic_ip_forceclear: '',
			reserve_plan: '',
			show_www: '',
			tarif_group: '',
			tarif_group_mask: '',
			transfer_allow: '',
			transfer_more_money_end_day: '',
			transfer_only_more_money: '',
			updatetime: '',
			users_balance_warning: '',
			users_limit: '',
			users_limit_warning: '',
			usluga_allow_all: '',
			usluga_range_type: { do_notify_changes: '', id: '', name: '', operator: '', pk: '', __self: '' },
			__self: '',
			__usluga_range_type: '',
			error: '',
			login_error: '',
			message: '',
		},
		error: null,
	},
	loading: false,
	error: '',
};

export const fetchCurrentTarif = createAsyncThunk('api/fetchCurrentTarif', (action: string) =>
	api.fetchCurrentTarif(action),
);

const currentTarifSlice = createSlice({
	name: 'currentTarif',
	initialState,
	reducers: {},
	extraReducers(builder) {
		builder
			.addCase(fetchCurrentTarif.pending, (state) => {
				state.loading = true;
				state.error = '';
			})
			.addCase(fetchCurrentTarif.fulfilled, (state, action) => {
				state.loading = false;
				state.data = action.payload || {};
				state.error = '';
			})
			.addCase(fetchCurrentTarif.rejected, (state) => {
				state.loading = false;
				state.error =  'Ошибка при загрузке';
			});
	},
});

export default currentTarifSlice.reducer;
